import remoteFn from '../remote'
const remote = remoteFn()

const state = {
  defaultEvents: []
}

const getters = {
  DEFAULTEVENTS: state => {
    return state.defaultEvents
  },
  DEFAULT_EVENTS_AS_TITLE: (state) => {
    return state.defaultEvents.map(event => (event.data.title))
  }
}

const mutations = {
  SET_DEFAULTEVENTS: (state, payload) => {
    state.defaultEvents = payload
  }
}

const actions = {
  GET_DEFAULTEVENTS: async (context, payload) => {
    const { data } = await remote.get('/api/objectdatas/objectgroupid/10')
    context.commit('SET_DEFAULTEVENTS', data)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/defaultevents.js